export default __webpack_public_path__ + "static/tag-do-4-dark-cb9d14e9f1e1d057a7ef1e2b14eac0632a3862db2fe29fb28a5fe2026eb05b37.png";